
import { defineComponent } from "vue";
import Header from "@/components/HomeNav.vue";

export default defineComponent({
  name: "AddCard",
  components: {
    Header,
  },
  watch: {
    addCardForm: {
      handler(newValue) {
        // console.log("handler: " + newValue.cardNumber);
        // start : cardNumber
        let cardNumber = newValue.cardNumber.replace(/\D/g, "");
        if (cardNumber) {
          let v = cardNumber.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
          let matches = v.match(/\d{4,16}/g);
          let match = (matches && matches[0]) || "";
          let parts = [];

          for (let i = 0, len = match.length; i < len; i += 4) {
            parts.push(match.substring(i, i + 4));
          }

          if (parts.length) {
            cardNumber = parts.join("-");
          }
        }
        if (cardNumber != newValue.cardNumber) {
          this.addCardForm.cardNumber = cardNumber;
        }
        // end : cardNumber
        // start : cvv
        let cvv = newValue.cvv.replace(/\D/g, "");
        if (cvv) {
          cvv = cvv.slice(0, 3);
        }
        if (cvv != newValue.cvv) {
          this.addCardForm.cvv = cvv;
        }
        // end : cvv
        // start : exriry
        let exriry = newValue.exriry.replace(/\D/g, "");
        if (exriry) {
          let v = exriry.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
          let matches = v.match(/\d{2,4}/g);
          let match = (matches && matches[0]) || "";
          let parts = [];

          for (let i = 0, len = match.length; i < len; i += 2) {
            parts.push(match.substring(i, i + 2));
          }

          if (parts.length) {
            exriry = parts.join("/");
          }
        }
        if (exriry != newValue.exriry) {
          this.addCardForm.exriry = exriry;
        }
        // end : exriry
      },
      deep: true,
    },
  },
  data() {
    return {
      addCardForm: {
        cardNumber: "",
        cardHolderName: "",
        exriry: "",
        cvv: "",
        defaultPayment: true,
      },
      addCardFormValidate: {
        cardNumber: false,
        cardHolderName: false,
        exriry: false,
        cvv: false,
      },
    };
  },
  methods: {
    checkCardNumberValidate() {
      this.addCardFormValidate.cardNumber = true;
      if (
        this.addCardForm.cardNumber &&
        this.addCardForm.cardNumber.length > 18
      ) {
        this.addCardFormValidate.cardNumber = false;
      }
    },
    checkCardHolderNameValidate() {
      this.addCardFormValidate.cardHolderName = true;
      if (this.addCardForm.cardHolderName) {
        this.addCardFormValidate.cardHolderName = false;
      }
    },
    checkCVVValidate() {
      this.addCardFormValidate.cvv = true;
      if (this.addCardForm.cvv && this.addCardForm.cvv.length > 2) {
        this.addCardFormValidate.cvv = false;
      }
    },
    checkExriryValidate() {
      this.addCardFormValidate.exriry = true;
      if (this.addCardForm.exriry) {
        this.addCardFormValidate.exriry = false;
      }
    },
    saveCard() {
      this.checkCardNumberValidate();
      this.checkCardHolderNameValidate();
      this.checkExriryValidate();
      this.checkCVVValidate();
      const validate =
        !this.addCardFormValidate.cardNumber &&
        !this.addCardFormValidate.cardHolderName &&
        !this.addCardFormValidate.cvv &&
        !this.addCardFormValidate.exriry;

      if (validate) {
        console.log(`saveCard`);
        this.$router.push("/payment");
      }
    },
  },
});
